<template>
    <div class="container-fluid">
        <div class="row py-5">
            <div
                class="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3 text-center"
            >
                <div
                    class="search-box"
                    @keydown.esc="hideSearchBox"
                    @keydown.enter="executeSearch"
                >
                    <input
                        ref="searchInput"
                        v-model="query"
                        v-validate="'required'"
                        :name="'search'"
                        :placeholder="[['Start jouw zoektocht']]"
                        class="website-search-button__input"
                        type="search"
                    />
                    <i class="fa fa-search" @click="executeSearch()"></i>
                </div>
            </div>
        </div>
        <div v-if="results.length > 0" class="row">
            <a :href="previousUrl" class="link">{{ previousUrlText }}</a>

            <div class="col-12">
                <h2 class="h1 mb-2">
                    Zoekresultaten <span class="h3">({{ totalResults }})</span>
                </h2>
            </div>

            <div class="col-12 col-lg-6">
                <SearchResult
                    v-for="resultItem in results"
                    :key="resultItem.id"
                    :result-item="resultItem"
                ></SearchResult>
                <div class="pagination-wrapper">
                    <a
                        v-for="(pageInt, index) in pages"
                        :key="index"
                        :class="page == pageInt ? 'active' : ''"
                        @click="setCurrentPage(pageInt)"
                        >{{ pageInt }}</a
                    >
                </div>
            </div>
        </div>
        <div v-if="results.length === 0" class="row">
            <div class="col-12">
                <h2 class="h1">Zoekresultaten</h2>
            </div>
            <div class="col-12">
                Geen resultaten gevonden voor
                <strong>"{{ currentQuery }}"</strong>
            </div>
        </div>
    </div>
</template>

<script>
import Axios from 'axios';
import SearchResult from '@/components/search/search-result';

export default {
    components: {
        SearchResult
    },
    props: {
        previousUrlText: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            results: [],
            resultCount: 0,
            images: [],
            pages: [],
            url: '/api/searchapi/search?q=',
            hideSearch: true,
            query: '',
            currentQuery: '',
            page: 1,
            previousUrl: ''
        };
    },
    computed: {
        totalResults() {
            return this.resultCount;
        }
    },
    mounted() {
        if (this.$route.query.q) {
            this.query = this.$route.query.q;
        }

        if (this.$route.query.page) {
            this.page = this.$route.query.page;
        }

        this.previousUrl = document.referrer;
        this.executeSearch();
    },

    methods: {
        getSearchResults() {
            Axios.get(this.url + this.query + '&page=' + this.page)
                .then(response => {
                    this.results = response.data.content.pagedResults;
                    this.resultCount = response.data.content.resultCount;
                    this.currentQuery = this.query;
                    this.pages = [];
                    for (let i = 0; i < response.data.content.pages; i++) {
                        this.pages.push(i + 1);
                    }

                    return true;
                })
                .catch(() => false);
        },
        executeSearch() {
            this.$router.push({ query: { q: this.query, page: 1 } });
            this.getSearchResults();
            const results = document.querySelector('#search-results');
            if (this.query !== '') {
                results.scrollIntoView({
                    behavior: 'smooth'
                });
            }
        },
        setCurrentPage(page) {
            this.page = page;
            this.$router.push({ query: { q: this.query, page: page } });
            this.getSearchResults();
            const results = document.querySelector('#search-results');
            if (this.query !== '') {
                results.scrollIntoView({
                    behavior: 'smooth'
                });
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.search-box {
    padding: 0;
    position: relative;
    overflow: hidden;
    border-radius: 23.5px;
    display: inline-block;
    max-width: 100%;
    width: 285px;
    border: solid 2px $color-blue;
    background-color: $color-blue;

    @include media-breakpoint-up(md) {
        width: 490px;
    }

    &:hover {
        transform: none;
    }

    i {
        color: $color-white;
        background-color: $color-blue;
        text-align: center;
        position: absolute;
        top: 0px;
        right: 0;
        line-height: 47px;
        width: 49px;
        height: 47px;
        font-size: 20px;
        cursor: pointer;

        @include media-breakpoint-up(md) {
            font-size: 25px;
            width: 67px;
        }
    }
}

.website-search-button__input {
    height: 47px;
    width: calc(100% - 50px);
    border: none;
    outline: none;
    color: $color-black;
    font-weight: $font-weight-light;
    float: left;
    transition: all 0.25s linear;
    background-color: white;
    padding-left: 25px;

    @include media-breakpoint-up(md) {
        width: calc(100% - 67px);
    }

    &::placeholder {
        color: $color-black;
        font-style: italic;
    }
}

.pagination-wrapper {
    a {
        padding: 5px 11px;
        border: 2px solid $color-blue;
        background: $color-white;
        color: $color-blue;
        margin-right: 15px;

        &:hover {
            cursor: pointer;
        }

        &.active {
            border: 2px solid $color-blue;
            background: $color-blue;
            color: $color-white;
        }
    }
}
</style>
